export enum OutcomeCategory {
    FALL = 'FALL',
    TREMORS = 'TREMORS',
}
